import { render } from "./MethanogenList.vue?vue&type=template&id=a568db6c"
import script from "./MethanogenList.vue?vue&type=script&lang=js"
export * from "./MethanogenList.vue?vue&type=script&lang=js"

import "./MethanogenList.vue?vue&type=style&index=0&id=a568db6c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__